TS.ns('WL'); 

WL.leasingFolderBaseModel = new Class({
    Extends: WL.documentBase,
     

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var simulationList = me.getDomainProperty('grdSimulations_Property');

        if (me.Document.PeriodicityTypeId != undefined) {
            me.dueWeekDayIsVisible = ko.computed(function () {
                if (me.Document.PeriodicityTypeId() == WL.Config.PeriodicityType.WEEK)
                    return true;
                return false;
            });

            me.dueMonthDayIsVisible = ko.computed(function () {
                if (me.Document.PeriodicityTypeId() == WL.Config.PeriodicityType.MONTH)
                    return true;
                return false;
            });
        }

        if (me.Document.AdditionalInterestTypeId != undefined) {
            me.showInterestType = ko.computed(function () {
                if (me.Document.AdditionalInterestTypeId() === WL.Config.AdditionalInterestType.VARIABLE)
                    return true;
                return false;
            });
        }

        if (me.Document.InterestTypeId != undefined) {
            me.variableInterestIsVisible = ko.computed(function () {
                if (me.Document.InterestTypeId())
                    return true;
                return false;
            });
        }

        if (me.Document.FinanceRequest != undefined) {
            if (me.Document.FinanceRequest.RequestTypeId != undefined) {
                me.IsNewFinancing = ko.computed(function () {
                    if (me.Document.FinanceRequest.RequestTypeId() != null && me.Document.FinanceRequest.RequestTypeId() == WL.Config.FinanceRequestType.NewFinancing)
                        return true;
                    return false;
                });
                me.IsNotNewFinancing = ko.computed(function () {
                    if (me.Document.FinanceRequest.RequestTypeId() != null && me.Document.FinanceRequest.RequestTypeId() != WL.Config.FinanceRequestType.NewFinancing)
                        return true;
                    return false;
                });
            }
        }

        conditionsList = me.getDomainProperty('dgDocumentConditionCollection_Property');
        if (conditionsList != null) {
            conditionsList.on('cellBeginEdit', me.onConditionsGridBeginEdit);
        }

        me.uploadScoringEnabled = ko.computed(function () {
            if (me.CanUploadScoringInfo != null)
                if (me.CanUploadScoringInfo() && me.ScoringSectionIsVisible())
                    return true;
            return false;
        });

        me.showCreditLimitAmount = ko.computed(function () {
            if (me.Document.ContractTypeId) {
                var isInList = false;
                var contractTypeIdList = me.ContractTypeIdList();
                for (i = 0; i < contractTypeIdList.length; i++) {
                    if (parseInt(contractTypeIdList[i]) == me.Document.ContractTypeId()) {
                        isInList = true;
                    }
                }
                return isInList;
            }
            return false;
        });

        me.watchProperty(me.Document.ClientUniqueId, me.onUniqueIdChanged, me);

        var warrantyList = me.getDomainProperty('dgLeasingWarrantyCollection_Property');
        if (warrantyList != null) {

            warrantyList.on('afterAdd', me.onWarrantyAdded);
        }

        if (simulationList != null) {
            simulationList.getFieldByName('gcSimulationNumber_Field').renderer = "hyperlinkGrid";

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }
    },

    onConditionsGridBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'Fulfilled') {
        }
        else {
            if (e.fieldName == 'ResponsibleId') {
                if (e.record.Fulfilled() == true)
                    e.preventDefault();
            }
        }
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);
        var documentExceptionList = me.getDomainProperty('dgDocumentExceptionCollection_Property');
        var verificationList = me.getDomainProperty('dgVerification_Property');
        var simulationList = me.getDomainProperty('grdSimulations_Property');
        var financialIndicatorList = me.getDomainProperty('FinancialIndicatorsProperty');

        if (documentExceptionList != null) {
            documentExceptionList.on('afterAdd', me.onExceptionAdded);
        }

        var gridCategory = me.getDomainProperty('dgScoringDocumentData_Property');

        if (gridCategory != null) {
            gridCategory.on('cellBeginEdit', me.onScoringCategoryCellEdit);
            gridCategory.on('cellValueChanged', me.onOptionOrUserValueChanged);

            gridCategory.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.Computed == true || dataItem.ReadOnlyCategory == true) {
                            row.addClass("grey_readonly_scoring_category");
                        }
                    }
                }
            }
        }


        if (verificationList != null) {
            cat = verificationList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'AddVerification';
            cmd['Text'] = me.AddVerificationCommandText;
            cmd['handler'] = '_addVerification';
            cmd['IconCode'] = 'plus';
            if (!me.ReadOnly())
                cat.push(cmd);

            cmdAddItemVerification = new TS.domain.Command();
            cmdAddItemVerification['Code'] = 'AddItemVerification';
            cmdAddItemVerification['Text'] = me.AddItemVerificationCommandText;
            cmdAddItemVerification['handler'] = '_addItemVerification';
            cmdAddItemVerification['IconCode'] = 'plus';
            if (!me.ReadOnly())
                cat.push(cmdAddItemVerification);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'RefreshFinancialInfoData';
            newCmd['Text'] = me.RefreshFinancialInfoDataCommandText;
            newCmd['handler'] = '_refreshFinancialInfoData';
            newCmd['IconCode'] = 'refresh';
            if (!me.ReadOnly())
                cat.push(newCmd);
        }

        if (simulationList != null) {
            cat = simulationList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddSimulation';
            newCmd['Text'] = me.AddSimulationCommandText;
            newCmd['handler'] = '_addSimulation';
            newCmd['IconCode'] = 'plus';

            if (!me.ReadOnly())
                cat.push(newCmd);

            simulationList.on('cellBeginEdit', me.onSimulationBeginEdit);
        }

        if (financialIndicatorList != null) {

            financialIndicatorList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);

                        if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Bold) {
                            row.addClass("scoring_financialIndicator_bold_row");
                        }

                        if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Bold_Red) {
                            row.addClass("scoring_financialIndicator_bold_red_row");
                        }

                        if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Italic) {
                            row.addClass("scoring_financialIndicator_italic_row");
                        }
                    }
                }
            }

            cat = financialIndicatorList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'SelectIndicatorDimension';
            newCmd['Text'] = me.SelectIndicatorDimensionCommandText;
            newCmd['handler'] = '_selectIndicatorDimension';
            newCmd['IconCode'] = 'ellipsis-v';

            if (!me.ReadOnly())
                cat.push(newCmd);
        }

        var engineScoringList = me.getDomainProperty('ScoringEngineList');
        if (engineScoringList) {
            engineScoringList.on('selectionChanged', me._onEngineScoringChanged, me);
        }

        classificationList = me.getDomainProperty('dgClassification_Property');
        if (classificationList) {
            classificationList.on('cellBeginEdit', me._onClassificationSelectedItemChanged);

            classificationList.customiseOptions = function (options) {
                options.dataBound = function (e) { 
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (!dataItem.RowIsVisible) {
                            row.hide();
                            continue;
                        }
                    }
                }
            }
        }

        documentConditionList = me.getDomainProperty('dgDocumentConditionCollection_Property');
        if (documentConditionList != null) {
            documentConditionList.on('cellValueChanged', me.onFulfilledChanged);
            documentConditionList.on('afterAdd', me.onConditionAdded);
        }

        if (me.lkpResponsible_Property != undefined) {
            me.lkpResponsible_Property.on('selectionChanged', me.onResponsibleIdChanged, me);
        }

        documentChecklistList = me.getDomainProperty('dgCheckList_Property');
        if (documentChecklistList != null) {
            documentChecklistList.on('afterAdd', me.onChecklistAdded);
            documentChecklistList.on('cellValueChanged', me.onChecklistChanged);
        }

        approvalsList = me.getDomainProperty('dgApprovals_Property');
        if (approvalsList) {
            cat = approvalsList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddApprovals';
            newCmd['Text'] = me.AddCommandText;
            newCmd['handler'] = '_addApprovals';
            newCmd['IconCode'] = 'plus';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'EditApprovals';
            newCmd['Text'] = me.EditCommandText;
            newCmd['handler'] = '_editApprovals';
            newCmd['IconCode'] = 'edit';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DelApprovals';
            newCmd['Text'] = me.DelCommandText;
            newCmd['handler'] = '_delApprovals';
            newCmd['IconCode'] = 'remove';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'EscalateApprovals';
            newCmd['Text'] = me.EscalateApprovalCommandText;
            newCmd['handler'] = '_escalateApprovals';
            newCmd['IconCode'] = 'arrow-up';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'ViewApprovalHistory';
            newCmd['Text'] = me.ViewApprovalHistoryCommandText;
            newCmd['handler'] = '_viewApprovalsHitory';
            newCmd['IconCode'] = 'history';
            if (!me.ReadOnly())
                cat.push(newCmd);
        }

        var partnerList = me.getDomainProperty('dgLeasingPartnerCollection_Property');
        if (partnerList) {
            partnerList.on('afterAdd', me.onPartnerAdded);
            partnerList.getFieldByName('gcPartner_Field').allowInput = false;
            partnerList.getFieldByName('gcPartnerForDealers_Field').allowInput = false;
            partnerList.getFieldByName('gcPartner_Field').on('propertyChanged', me.onPartnerChanged, me);
            partnerList.getFieldByName('gcPartnerForDealers_Field').on('propertyChanged', me.onPartnerChanged, me);
            if (me.PartnerSearchInterfaceEnabled()) {
                partnerList.getFieldByName('gcPartner_Field').Visible(false);
                partnerList.getFieldByName('gcPartnerForDealers_Field').Visible(false);
            }
            else {
                partnerList.getFieldByName('gcPartnerName_Field').Visible(false);
                if (me.IsDealerUser()) {
                    partnerList.getFieldByName('gcPartner_Field').Visible(false);
                }
                else {
                    partnerList.getFieldByName('gcPartnerForDealers_Field').Visible(false);
                }
            }
            partnerList.on('cellBeginEdit', me.onAssociatedPartnerGridBeginEdit);    

            partnerList.getFieldByName('gcPartnerName_Field').renderer = "iconsRenderer";

            TS.UI.Renderers.grid.iconsRenderer = {

                getCellContent: function (field, dataItem) {
                    var displayText = '&nbsp';
                    if (dataItem.PartnerName !== null)
                        displayText = dataItem.PartnerName;
                    var content = 
                         displayText
                        + '<div class="grid-cell icon-cell" style="float: right">'
                            + '<div class="grid-cell-icon">'
                            + '<a class="ts-grid-command" type="hyperlink" onclick="javascript: TS.UI.models.peek().onAssociatedPartnerSearch(' + dataItem.UID + ');">'
                            + '<i class="fa fa-search"></i></a></div>'

                            + '<div class="grid-cell-icon">'
                            + '<a class="ts-grid-command" type="hyperlink" onclick="javascript: TS.UI.models.peek().onAssociatedPartnerReset();">'
                            + '<i class="fa fa-remove"></i></a></div>'

                        + '</div>';

                    return content;
                }
            };
        }              


        var warrantyList = me.getDomainProperty('dgLeasingWarrantyCollection_Property');
        if (warrantyList != null) {
            warrantyList.getFieldByName('gcGuarantor_Field').allowInput = false;
            warrantyList.getFieldByName('gcGuarantorForDealers_Field').allowInput = false;
            if (me.IsDealerUser()) {
                warrantyList.getFieldByName('gcGuarantor_Field').Visible(false);
            }
            else {
                warrantyList.getFieldByName('gcGuarantorForDealers_Field').Visible(false);
            }
        } 

        var knockoutCriteriaList = me.getDomainProperty('dgKnockoutCriteriaCollection_Property');
        if (knockoutCriteriaList) {
            knockoutCriteriaList.on('cellBeginEdit', me.onKnockoutCriteriaBeginEdit, me);
            knockoutCriteriaList.on('cellValueChanged', me.onResultChanged, me);
        }
    },

    onPartnerAdded: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;

        rec.PartnerTypeId = new ko.observable(null);
        rec.PartnerTypeName = new ko.observable(null);
        rec.DocumentPartnerId = new ko.observable(null);

        owner.performServerCommand('Dummy', true, null, null, false, true);
    },

    onAssociatedPartnerGridBeginEdit: function (e) {
        var me = this;

        if (e.record.DocumentPartnerId() != null)
            e.preventDefault();
    },

    onAssociatedPartnerSearch: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'SearchLeasingPartner',
            submitModel: true,
            extraData: {
                UID: e
            },
            blockUI: true
        });
    },


    onAssociatedPartnerReset: function(e) {
        var me = this;

        var partnerList = me.getDomainProperty('dgLeasingPartnerCollection_Property');
        if (partnerList && partnerList.SelectedItem()) {
            partnerList.SelectedItem().PartnerId(null);
            partnerList.SelectedItem().PartnerName(null);
            partnerList.SelectedItem().ContactPersonId(null);
            partnerList.SelectedItem().ContactPersonName(null);
        }
    },

    
    onPartnerChanged: function(selectedRecord) {
        var me = this,
            partnerList = me.getDomainProperty('dgLeasingPartnerCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            partnerList.SelectedItem().PartnerTypeId(selectedRecord.sender.SelectedItem().PartnerTypeId); 
            partnerList.SelectedItem().PartnerTypeName(selectedRecord.sender.SelectedItem().PartnerTypeName);
        }
    },


    onKnockoutCriteriaBeginEdit: function (e) {
        var me = this,
          rec = e.item;

        if (!me.CanEditKOCriteria())
            e.preventDefault();
    }, 
     
    onScoringCategoryCellEdit: function (e) {
        var me = this,
            owner = me._Domain,
            categoryList = owner.getDomainProperty('dgScoringDocumentData_Property'); 

        if (e.fieldName == 'ScoringDetailId' && (categoryList.SelectedItem().Computed() || categoryList.SelectedItem().ReadOnlyCategory()))
            e.preventDefault();

        if (e.fieldName == 'UserValue' && (categoryList.SelectedItem().InputTypeId() == WL.Config.ScoringCategoryInputType.SELECTION_LIST || categoryList.SelectedItem().ReadOnlyCategory() || categoryList.SelectedItem().Computed()))
            e.preventDefault();
    },

    onOptionOrUserValueChanged: function (e) { 
        var me = this,
          rec = e.item,
          owner = me._getOwner(),
          categoryList = owner.getDomainProperty('dgScoringDocumentData_Property');

        if (e.fieldName == 'UserValue') {
            owner.performServerCommand({
                cmd: 'UpdateScoringCategoryOptionOrValue',
                submitModel: true,
                extraData: {
                    IsUserValueModified: true,
                    ScoringCategoryId: categoryList.SelectedItem().ScoringId(),
                    ScoringCategoryDetailId: categoryList.SelectedItem().ScoringDetailId(),
                    UserValue: categoryList.SelectedItem().UserValue()
                },
                blockUI: true
            });
        }

        if (e.fieldName == 'ScoringDetailId') {
            owner.performServerCommand({
                cmd: 'UpdateScoringCategoryOptionOrValue',
                submitModel: true,
                extraData: {
                    IsUserValueModified: false,
                    IsNumericInputType: categoryList.SelectedItem().InputTypeId() == WL.Config.ScoringCategoryInputType.NUMERIC,
                    ScoringCategoryId: categoryList.SelectedItem().ScoringId(),
                    ScoringCategoryDetailId: categoryList.SelectedItem().ScoringDetailId(),
                    UserValue: categoryList.SelectedItem().UserValue()
                },
                blockUI: true
            });
        }
    },

    onSimulationBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'SimulationNumber') {
            e.preventDefault();
            owner.performServerCommand({ cmd: 'EditSimulation', submitModel: true, extraData: { SimulationId: e.record.DocumentId, SimulationSiteId: e.record.SiteId }, blockUI: true });
        }
        else if (owner.ReadOnly) {
            e.preventDefault();
        }
    },

    _addSimulation: function (e) {
        var me = this;

        me.performServerCommand({ cmd: 'AddSimulation', submitModel: true, extraData: {}, blockUI: true });
    },

    _onClassificationSelectedItemChanged: function (e) {
        var me = this;
        owner = me._getOwner();
        owner.performServerCommand({ cmd: 'SelectedClassificationChanged', submitModel: true, extraData: { UID: e.record.UID }, blockUI: true });
        e.preventDefault();
    },

    _addVerification: function () {
        var me = this;
    
        me.performServerCommand({
            cmd: 'AddVerification',
            submitModel: true,
            blockUI: false
        });
    },

    _addItemVerification: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddItemVerification',
            submitModel: true,
            blockUI: false
        });
    },

    _refreshFinancialInfoData: function () {
        var me = this;
        // instruct parent model to perform command
        me.performServerCommand({ cmd: 'RefreshFinancialInfoData', submitModel: true, extraData: {}, blockUI: true });
    },

    _onEngineScoringChanged: function () {
        var me = this;
         
        me.performServerCommand({
            cmd: 'ScoringEngineChanged', submitModel: true, blockUI: true,
            callback: function () {
                me.getDomainProperty('FinancialIndicatorsProperty').invalidate();

            }
        });
    },

    onWarrantyAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.CurrencyId(WL.Config.LegalCurrency.Id);
        e.item.CurrencyCode(WL.Config.LegalCurrency.Code);
        owner.performServerCommand('Dummy', true, null, null, false, true);
    },
    onExceptionAdded: function (e) {
        var me = this,
            owner = me._Domain;
        e.item.UserId = owner.CurrentUserId();
        e.item.UserName(owner.CurrentUserName());
        var now = new Date();
        now.setHours(0, 0, 0, 0);
        e.item.InternalTime(now);
    },

    onConditionAdded: function (e) {
        var me = this,
            owner = me._Domain;
        if (owner.CurrentPersonName() != null) {
            e.item.ApproverId = owner.CurrentPersonId();
            e.item.ApproverName(owner.CurrentPersonName());
        }
    },

    onFulfilledChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'Fulfilled') {
            val = e.newValue;
            if (val != null && val == true) {
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                e.record.CheckDate(now);
                if (owner.CurrentPersonName() != null) {
                    me.SelectedItem().ResponsibleId(owner.CurrentPersonId());
                    me.SelectedItem().ResponsibleName(owner.CurrentPersonName());
                }
            }
            else {
                e.record.CheckDate(null);
            }
        }
    },

    onVerificationCellEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'VerificationName') {
            e.preventDefault();

            owner.performServerCommand({
                cmd: 'DownloadVerificationFromDMS',
                submitModel: true,
                extraData: {
                    rowIdx: e.rowIdx
                },
                blockUI: true
            })
            
        }
        else if (owner.ReadOnly && e.fieldName != 'FreeTxt') {
            e.preventDefault();
        }

    },

    onUniqueIdChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'LoadPartner',
            submitModel: true,
            extraData: { UniqueID: newValue },
            blockUI: false
        });
    },

    onResponsibleIdChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'UpdateResponsible',
            submitModel: true,
            blockUI: true
        });
    },

    onChecklistChanged: function (e) {
        

        var me = this,
            owner = me._Domain,
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'Finalized') {
            val = e.newValue;
            if (val != null && val == true) {
                setTimeout(function () {
                    var now = new Date();
                    now.setHours(0, 0, 0, 0);
                    e.record.FinalizedDate(now);
                    if (owner.CurrentUserId() != null) {
                            e.record.UserId(owner.CurrentUserId());
                            e.record.UserName(owner.CurrentUserName());
                    }
                }, 0)
            }
            else {
                setTimeout(function () {
                    e.record.FinalizedDate(null);
                    e.record.UserId(null);
                    e.record.UserName(null);
                }, 0)
            }
        }
    },

    onChecklistAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.Finalized(false);
    },

    _addApprovals: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddApprovals',
            submitModel: true,
            blockUI: false
        });
    },

    _editApprovals: function () {
        var me = this;
        approvalsList = me.getDomainProperty('dgApprovals_Property');

        if (approvalsList.SelectedItem() == null) return;

        me.performServerCommand({
            cmd: 'EditApprovals',
            submitModel: true,
            extraData: { UID: approvalsList.SelectedItem().UID() },
            blockUI: false
        });
    },

    _delApprovals: function () {
        var me = this;

        var approvalsList = me.getDomainProperty('dgApprovals_Property');
        if (approvalsList.SelectedItem() == null) {
            me.performServerCommand({
                cmd: 'DeleteApprovals',
                submitModel: true,
                extraData: null,
                blockUI: true,
                extraData: {
                    UID: null
                }
            });
        } else {
            me.performServerCommand({
                cmd: 'DeleteApprovals',
                submitModel: true,
                extraData: null,
                blockUI: true,
                extraData: {
                    UID: approvalsList.SelectedItem().UID()
                }
            });
        }
    },

    _escalateApprovals: function () {
        var me = this;

        var approvalsList = me.getDomainProperty('dgApprovals_Property');
        if (approvalsList.SelectedItem() == null) {
            me.performServerCommand({
                cmd: 'EscalateApprovals',
                submitModel: true,
                extraData: null,
                blockUI: true,
                extraData: {
                    UID: null
                }
            });
        } else {
            me.performServerCommand({
                cmd: 'EscalateApprovals',
                submitModel: true,
                extraData: null,
                blockUI: true,
                extraData: {
                    UID: approvalsList.SelectedItem().UID()
                }
            });
        }
    },

    _viewApprovalsHitory: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'ViewApprovalsHistory',
            submitModel: true,
            blockUI: false
        });
    },

    _selectIndicatorDimension: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'SelectIndicatorDimension',
            submitModel: true,
            blockUI: true,
            callback: function () {
                me.getDomainProperty('FinancialIndicatorsProperty').invalidate();

            }

        });
    },

    onResultChanged: function (e) {
        var me = this,
            knockoutCriteriaList = me.getDomainProperty('dgKnockoutCriteriaCollection_Property');

        if (e.fieldName != 'Result')
            return;

        if (e.record) {
            e.record.ManualYN(true);
            e.record.ManualYNText(me.DecisionTypeManualText());
            e.record.ModifiedBy(me.CurrentUserId());
            e.record.ModifiedByName(me.CurrentUserName());
            var now = new Date();
            e.record.ModifiedDate(now);
        }
    }
});
